import { render, staticRenderFns } from "./GalleryTest.vue?vue&type=template&id=acbb73ba&scoped=true&"
import script from "./GalleryTest.vue?vue&type=script&lang=js&"
export * from "./GalleryTest.vue?vue&type=script&lang=js&"
import style0 from "./GalleryTest.vue?vue&type=style&index=0&id=acbb73ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acbb73ba",
  null
  
)

export default component.exports